<div
  class="visual-builder-block"
  [class.selected]="selectedId?.id?.includes('card')"
>
  <div
    class="movement-block"
    [ngClass]="'movement-block-' + number.status"
    [ngStyle]="{
      backgroundColor: card?.backgroundColor,
      boxShadow: card?.shadow,
      borderColor: card?.borderColor,
      'borderWidth.px': card?.borderWidth,
      'borderRadius.px': card?.borderRadius
    }"
    (click)="selectCard($event, button, buttonText)"
  >
    <div
      class="movement-block-top"
      [ngStyle]="{ 'background-color': card?.headerBackground }"
    >
      <div class="media">
        <i class="icon-{{ number.status }} icon-big"></i>
        <div class="media-body number-tn-container pr-4">
          <div
            class="number-tn"
            [ngStyle]="card | fontFamily"
            [fittext]="true"
            [activateOnResize]="true"
            [minFontSize]="14"
            [maxFontSize]="24"
          >
            {{ number.display }}
          </div>
          <p class="dop-info" [ngStyle]="card | fontFamily">
            <app-tracking-page-status
              [status]="number.status"
            ></app-tracking-page-status>
            :
            <app-tracking-page-status-text
              [status]="number.status"
            ></app-tracking-page-status-text>
          </p>
        </div>
        <div class="from-to-container mt-1" [style.max-width.px]="240">
          <div class="tracking-item-block carriers-block">
            <div
              class="left-bl d-flex"
              *ngIf="
                number?.originCarrier?.image ||
                number?.originCarrier?.phone ||
                number?.originCarrier?.url
              "
            >
              <div
                class="position-relative inline-flex align-content-center align-items-center"
              >
                <img
                  *ngIf="number?.originCarrier?.image"
                  alt="{{ number?.originCarrier?.name }}"
                  [attr.src]="imageUrl + number?.originCarrier?.image"
                  [style.height.px]="20"
                />
                <span
                  [title]="number?.originCarrier?.name"
                  class="fs-12 fw-600 mx-1 text-ellipsis"
                  [style.line-height.px]="12"
                  [style.max-width.px]="75"
                  [ngStyle]="card | fontFamily"
                >
                  {{ number?.originCarrier?.name }}
                </span>
                <div
                  class="cursor-pointer position-relative d-flex align-center"
                  [matMenuTriggerFor]="originCarrier"
                  *ngIf="
                    number?.originCarrier?.phone || number?.originCarrier?.url
                  "
                  (click)="toggleInfoDropDown('origin')"
                >
                  <i class="icon-ic_29 lightish-blue fs-12"></i>
                </div>
                <mat-menu
                  #originCarrier="matMenu"
                  class="dropdown-content dropdown-menu tracking-item-dropdown dropdown-menu-table bg-gray show"
                >
                  <div [ngStyle]="card | fontFamily">
                    <span
                      *ngIf="number?.originCarrier?.phone"
                      class="bg-gray dropdown-item fs-16 clearfix cursor-initial"
                    >
                      <span>{{ 'phone' | translate }}</span
                      >: {{ number?.originCarrier?.phone }}
                    </span>
                    <span
                      *ngIf="number?.originCarrier?.url"
                      class="dropdown-item bg-gray fs-16 clearfix cursor-initial"
                    >
                      <span>{{ 'homepage' | translate }}</span
                      >:
                      <a
                        class="blue-link"
                        [style.color]="card?.linksColor"
                        [attr.href]="number?.originCarrier?.url"
                        target="_blank"
                      >
                        {{ number?.originCarrier?.url }}
                      </a>
                    </span>
                  </div>
                  <div
                    class="dropdown-item bg-gray fs-12 clearfix cursor-initial carrier-description"
                    *ngIf="number.originCarrier?.description"
                  >
                    <i
                      class="icon-fileboard fs-14 copy-icon"
                      (click)="copyDescription(originCarrier)"
                    ></i>
                    <p
                      class="carrier-description__text"
                      [ngStyle]="card | fontFamily : 'fontFamily'"
                      [innerHTML]="number.originCarrier?.description"
                    ></p>
                    <textarea
                      class="carrier-description__textarea"
                      #originCarrier
                      [value]="number.originCarrier?.description"
                      readonly="true"
                    >
                    </textarea>
                  </div>
                </mat-menu>
              </div>
            </div>

            <span
              class="carriers-arrow d-flex fs-12"
              *ngIf="
                number?.originCarrier?.name !==
                  number?.destinationCarrier?.name &&
                (number?.destinationCarrier?.image ||
                  number?.destinationCarrier?.phone ||
                  number?.destinationCarrier?.url)
              "
              [ngStyle]="card | fontFamily"
            >
              →
            </span>

            <div
              class="left-bl d-flex"
              *ngIf="
                number?.originCarrier?.name !==
                  number?.destinationCarrier?.name &&
                (number?.destinationCarrier?.image ||
                  number?.destinationCarrier?.phone ||
                  number?.destinationCarrier?.url)
              "
            >
              <div
                class="position-relative inline-flex align-content-center align-items-center"
              >
                <img
                  *ngIf="number?.destinationCarrier?.image"
                  [attr.src]="imageUrl + number?.destinationCarrier?.image"
                  alt="{{ number?.destinationCarrier?.name }}"
                  [style.height.px]="20"
                />
                <a
                  [title]="number?.destinationCarrier?.name"
                  class="fs-12 fw-600 mx-1 text-ellipsis"
                  [style.line-height.px]="12"
                  [style.max-width.px]="70"
                  [ngStyle]="card | fontFamily"
                >
                  {{ number?.destinationCarrier?.name }}
                </a>
                <div
                  class="cursor-pointer position-relative d-flex align-center"
                  *ngIf="
                    number?.destinationCarrier?.phone ||
                    number?.destinationCarrier?.url
                  "
                  [matMenuTriggerFor]="appMenu"
                >
                  <i class="icon-ic_29 lightish-blue fs-12"></i>
                </div>
                <mat-menu
                  #appMenu="matMenu"
                  class="dropdown-content dropdown-menu tracking-item-dropdown dropdown-menu-table bg-gray show"
                >
                  <div [ngStyle]="card | fontFamily">
                    <span
                      (click)="
                        $event.stopPropagation(); $event.preventDefault()
                      "
                      *ngIf="number?.destinationCarrier?.phone"
                      class="bg-gray dropdown-item fs-16 clearfix cursor-initial"
                    >
                      <span>{{ 'phone' | translate }}</span
                      >: {{ number?.destinationCarrier?.phone }}
                    </span>
                    <span
                      *ngIf="number?.destinationCarrier?.url"
                      class="dropdown-item bg-gray fs-16 clearfix cursor-initial"
                    >
                      <span>{{ 'homepage' | translate }}</span
                      >:
                      <a
                        class="blue-link"
                        [style.color]="card?.linksColor"
                        [attr.href]="number?.destinationCarrier?.url"
                        target="_blank"
                      >
                        {{ number?.destinationCarrier?.url }}
                      </a>
                    </span>
                  </div>
                  <div
                    (click)="$event.stopPropagation(); $event.preventDefault()"
                    class="dropdown-item bg-gray fs-12 clearfix cursor-initial carrier-description"
                    *ngIf="number.destinationCarrier?.description"
                  >
                    <i
                      class="icon-fileboard fs-14 copy-icon"
                      (click)="copyDescription(destinationCarrier)"
                    ></i>
                    <p
                      class="carrier-description__text"
                      [ngStyle]="card | fontFamily : 'fontFamily'"
                      [innerHTML]="number.destinationCarrier?.description"
                    ></p>
                    <textarea
                      class="carrier-description__textarea"
                      #destinationCarrier
                      [value]="number.destinationCarrier?.description"
                      readonly="true"
                    >
                    </textarea>
                  </div>
                </mat-menu>
              </div>
            </div>
          </div>
          <div class="tracking-item-block fs-12" [style.margin-top.px]="15">
            <div
              class="media"
              [ngStyle]="card | fontFamily"
              *ngIf="!!number.originCountry"
            >
              <p class="m-0">
                <span class="fw-600">{{ 'from' | translate }}</span>
                <span class="fw-600">: </span>
                <span class="media-body">
                  {{ number.originCountry }}
                </span>
              </p>
            </div>
            <span
              class="carriers-arrow d-flex fs-12"
              [ngStyle]="card | fontFamily"
              *ngIf="!!number.originCountry"
              >→</span
            >
            <div
              class="media"
              [ngStyle]="card | fontFamily"
              *ngIf="!!number.destinationCountry"
            >
              <p class="m-0">
                <span class="fw-600">{{ 'to' | translate }}</span>
                <span class="fw-600">: </span>
                <span class="media-body">{{ number.destinationCountry }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /movement-block-top -->
    <div
      class="movement-block-content"
      [ngStyle]="{
        backgroundColor: card?.backgroundColor,
        borderLeftColor: card?.backgroundColor || '#ced2dc',
        borderRightColor: card?.backgroundColor || '#ced2dc'
      }"
    >
      <div class="movement-steps row" [class.open]="open">
        <div
          class="movement-step col"
          *ngFor="let status of statusLane; let i = index"
          [class.active]="number.status | trackingItemStatus : null : i"
        >
          <div class="timeline">
            <div class="line empty"></div>
            <div
              class="chircle"
              [style.background-color]="card?.backgroundColor"
            >
              <div class="inner-chircle">
                <i
                  class="icon-{{ number.status | trackingItemStatus : status }}"
                ></i>
              </div>
            </div>
            <div class="line"></div>
          </div>
          <div class="name-step" [ngStyle]="card | fontFamily">
            <app-tracking-page-status
              [status]="number.status | trackingItemStatus : status"
            ></app-tracking-page-status>
          </div>
        </div>
      </div>
      <!-- /movement-steps -->
      <div
        class="right-bl expected-delivery-date fs-12 mb-4 ml-2"
        [class.open]="open"
        [ngStyle]="card | fontFamily"
      >
        <p class="m-0" *ngIf="!!number?.expectedDeliveryDate">
          <span class="fw-600">{{ 'expected_delivery_date' | translate }}</span>
          <span class="fw-600">: </span>
          <span>{{
            number?.expectedDeliveryDate | dateFormat : 'yyyy-MM-dd'
          }}</span>
        </p>
      </div>
      <p
        *ngIf="number.originCarrier?.code === 'dpd-ru'"
        style="color: #f00; font-size: 26px"
      >
        Информация по отслеживанию посылок DPD Russia временно доступна только
        на сайте dpd.ru<br />Чтобы отследить свою посылку перейдите по ссылке
        <a
          href="https://www.dpd.ru/ols/trace2/standard.do2?orderNum={{
            number.display
          }}"
          >https://www.dpd.ru/ols/trace2/standard.do2?orderNum={{
            number.display
          }}</a
        >
      </p>
      <div class="wraper-details-tn boder-top pt-0" [class.open]="open">
        <div class="details-tn position-relative" style="min-height: 100px">
          <div
            class="loader inner-right-img text-center"
            *ngIf="checkpointsLoading"
          >
            <div>
              <img src="/assets/img/spinner.gif" height="70" alt="loading" />
              <p class="loading">Loading</p>
            </div>
          </div>
          <div *ngIf="!checkpointsLoading">
            <div
              class="tn ml-3"
              [class.active]="first"
              *ngFor="let checkpoint of checkpoints; let first = first"
            >
              <i class="" [style.background-color]="card?.backgroundColor"></i>
              <div class="inner-tn" [class.bold]="first">
                <span class="data-tn" [ngStyle]="card | fontFamily">{{
                  checkpoint.checkpointDate | dateUtcFormat : 'yyyy-MM-dd'
                }}</span>
                <span class="time-tn" [ngStyle]="card | fontFamily">{{
                  checkpoint.checkpointDate | dateUtcFormat : 'hh:mm a'
                }}</span>
                <p class="description-tn" [ngStyle]="card | fontFamily">
                  {{ checkpoint.info
                  }}{{ checkpoint.location ? ', ' + checkpoint.location : '' }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- /details-tn -->
      </div>
    </div>
    <!-- /movement-block-content -->
    <div
      class="movement-block-bottom clearfix"
      [style.backgroundColor]="card?.footerBackground"
    >
      <div class="left-block-bottom">
        <div
          class="review-block fs-10"
          *ngIf="reviewEnabled && number.status === 'delivered'"
          [ngStyle]="card | fontFamily"
        >
          <div
            class="mr-2"
            *ngIf="getCeilReview(number.review) === 0.0; else hasReview"
          >
            <span>
              {{ 'review_question' | translate }}
            </span>
            <a
              [style.color]="card?.linksColor"
              [style.text-decoration]="
                card?.linksUnderline ? 'underline' : 'none'
              "
              class="link-no-href"
              (click)="showFeedback.emit()"
            >
              {{ 'leave_review' | translate }}
            </a>
          </div>
          <ng-template #hasReview>
            <div class="mr-2">
              <a
                [ngStyle]="{
                  color: card?.linksColor,
                  textDecoration: card?.linksUnderline ? 'underline' : 'none'
                }"
                class="link-no-href"
                (click)="showFeedback.emit()"
              >
                {{ 'review' | translate }}
              </a>
            </div>
          </ng-template>
          <app-review-stars
            (click)="showFeedback.emit(number.review)"
            [disabled]="true"
            [value]="getCeilReview(number.review)"
          >
          </app-review-stars>
        </div>
      </div>
      <div class="right-block-bottom">
        <span class="last-updated" [ngStyle]="card | fontFamily"
          ><span>{{ 'last_updated' | translate }} </span>:
          <span>{{ number.updatedAt | dateFormat : 'yyyy-MM-dd hh:mm' }} </span>
        </span>
        <div
          class="visual-builder-block"
          [class.selected]="selectedId?.id?.includes('detailsButton')"
        >
          <button
            #button
            class="btn btn-default btn-lightish-blue text-capitalize btn-details min-w mb-0 show"
            type="button"
            [ngStyle]="
              detailsButton | fontFamily | assign : detailsButtonStyles
            "
            (click)="toggleDetails.emit({ id: number.id, open: !open })"
          >
            <span #buttonText class="hide-d">
              <span>
                {{
                  open
                    ? ('hide_details' | translate)
                    : ('show_details' | translate)
                }}
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div
      [style.backgroundColor]="card?.footerBackground"
      class="shipping-items-container py-3"
      *ngIf="number.items.length && orderItemsFrame?.on"
    >
      <app-tracking-page-order-items-frame
        [itemsFrame]="orderItemsFrame"
        [items]="number.items"
        [itemsOpened]="true"
        (selectBlock)="selectBlock.emit($event)"
        [selectedId]="selectedId"
      ></app-tracking-page-order-items-frame>
    </div>

    <!-- /movement-block-bottom -->
  </div>
</div>
